import React from "react";
import FavoriteNovel from "./FavoriteNovel";

function FavoriteNovels({ favoriteNovels }) {
  return (
    <div className="sm:mt-[80px] mt-[50px]">
      <div className="">
        <div className="Novels grid gap-4 sm:gap-8 md:gap-10 xl:grid-cols-5 lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-2 w-[100%] ">
          {/* <Novel /> */}
          {favoriteNovels?.map((novel, idx) => {
            return (
              <div key={novel._id}>
                <FavoriteNovel novel={novel} />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default FavoriteNovels;
